// ABOUTME: Hands a pre-linked item from a sidepanel action to the servicedesk workscreen via router state.
// ABOUTME: Builds the navigation target and lets the workscreen consume the prefill once, then clear it.

import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const STATE_KEY = 'newSupportTicket';

const WAREHOUSE_SERVICEDESK_PATH = '/warehouse/relations/servicedesk?view=workscreen';
const RELATION_SERVICEDESK_PATH = '/relation/servicedesk?view=workscreen';

// Returns the `navigate(to, { state })` arguments for opening the new-ticket modal
// with `linkedItem` already linked and, in the warehouse, `relationId` preselected.
export const buildNewSupportTicketNavigation = (isRelation, { linkedItem, relationId }) => ({
    to: isRelation ? RELATION_SERVICEDESK_PATH : WAREHOUSE_SERVICEDESK_PATH,
    state: {
        [STATE_KEY]: {
            linkedItems: [linkedItem],
            relationId: relationId ?? null,
        },
    },
});

// Reads the prefill from router state on arrival and immediately strips it from the
// history entry, so a refresh or back-navigation does not reopen the modal.
export const useNewSupportTicketPrefill = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [prefill, setPrefill] = useState(() => location.state?.[STATE_KEY] ?? null);

    useEffect(() => {
        const incoming = location.state?.[STATE_KEY];
        if (!incoming) return;
        setPrefill(incoming);
        navigate(`${location.pathname}${location.search}`, { replace: true, state: null });
    }, [location.state, location.pathname, location.search, navigate]);

    const clearPrefill = () => setPrefill(null);

    return { prefill, clearPrefill };
};
